<!-- 客服中心：/file_download/customerService | 法定揭露事項：/file_download/legalDisclosure -->
<template>
  <div class="layout_wrapper file_download_wrapper">
    <div class="container_wrapper">
      <h3 class="page_main_title">
        {{ pageInfo.title }}
      </h3>

      <div
        v-if="pageInfo.type === 'customerService'"
        class="file_download_sub_content"
      >
        <p>客服電話：02-2278-5200</p>
        <p>申請書審核信箱：service@pxpayplus.com</p>
      </div>

      <div class="file_download_list">
        <a
          v-for="(it, key) in currentList"
          :key="key"
          :href="it.url"
          target="_blank"
          class="file_download_list_item"
        >
          {{ it.fileName }}

          <img
            class="list_item_icon"
            src="@/assets/imgs/downloads.svg"
            alt="download_icon"
          >
        </a>
      </div>
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';
import { AppDialog } from '@/components/Modal/';
import { getDownloadsArea } from '@/libs/API/apis';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'FileDownload',
  components: {
    AppDialog
  },
  setup () {
    const { currentRoute, dialogName } = useCommon();
    const type = currentRoute.params.type || 'customerService';
    const typeCorrespondTitle = {
      customerService: '申請書下載',
      legalDisclosure: '法定揭露事項'
    };
    let downloadData = {};

    const pageInfo = ref({
      type,
      title: typeCorrespondTitle[type]
    });
    const currentList = ref([]);

    onBeforeRouteUpdate((to) => {
      pageInfo.value = {
        type: to.params.type,
        title: typeCorrespondTitle[to.params.type]
      };

      currentList.value = downloadData[pageInfo.value.title];
      document.title = pageInfo.value.title;
    });

    onMounted(() => {
      document.title = pageInfo.value.title;

      getDownloadsArea()
        .then((res) => {
          downloadData = res;

          currentList.value = downloadData[pageInfo.value.title];
        });
    });

    return {
      dialogName,
      type,
      pageInfo,
      currentList
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .file_download_sub_content {
    @include font-size-18;

    color: $mono_80;
    margin-bottom: 50px;

    p {
      margin: 0px;
    }
  }

  .file_download_list {
    .file_download_list_item {
      @include font-size-bold-24;

      border-bottom: 1px solid $mono_30;
      box-sizing: border-box;
      color: $black;
      display: block;
      min-height: 46px;
      margin-bottom: 30px;
      padding-right: 33px;
      position: relative;
      text-decoration: none;
    }

    .list_item_icon {
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
}
</style>
